import React from "react";

function Main() {
  return (
    <div className="main">
      <h1 className="name">Sungjin Park</h1>
      <h1>Full Stack Web Developer</h1>
    </div>
  );
}

export default Main;
